import { BillType, CancellationState, FulfillmentPositionDisplayMode, FulfillmentProductionState, FulfillmentState } from "./Enums";
import type { IBillItemTimerDiscount } from "./Bill";
import type { IFulfillmentGroup } from "./FulfillmentGroup";
import type { IOrderItem } from "./Order";
import type { IMultiLanguageText } from "./Shared";
import type { ITable } from "./Table";


//until now, this is only used for location corona client
export interface ITableCovidUserCount extends ITable {
    allocations: number;
}

export interface IRoomPlanTable extends ITable {
    allocations: number;
    openBillAmount?: number;
    status: RoomPlanTableStatus;
    timestamp?: Date;
    manualEndUsersCount?: number;
    openBillsCount: number;
    // when the longest running timer of the table would have started if it had run without stops, UTC. Undefined when no
    // timer is running
    longestRunningTimerStartedDateTime?: Date;
    // the running timers of the open table bill as it was read, openBillAmount holds their price of then: the room plan
    // counts it on with the clock of the device, with their item discounts
    openBillRunningTimers: IRoomPlanRunningTimer[];
    reservations: IRoomPlanTableTableReservation[];
}

export interface IRoomPlanRunningTimer {
    minuteRate: number;
    elapsedSeconds: number;
    elapsedReadDateTime: Date;
    // before and after its item discounts, as of the time it was read
    unitPrice: number;
    unitPriceAfterDiscount: number;
    unpaidQuantity: number;
    discounts: IBillItemTimerDiscount[];
}

export interface ShowSidebarEvent {
    showSideBar: boolean;
    showDim: boolean;
}

export interface IRoomPlanTableTableReservation {
    id: string;
    orderId: string;
    startDateTime: Date;
    endDateTime: Date;
    status: RoomPlanTableReservationStatus | undefined;
}

export enum RoomPlanTableStatus {
    Default = 0,
    OpenBill = 1,
    UnfulfilledOrder = 2,
    NoOrderMade = 3,
    TentativeReservation = 4,
    AssignedBeforeStartOfOccupancyDuration = 5,
    GuestsBeforeProductionDurationPartiallyArrived = 6,
    GuestsBeforeProductionDurationArrived = 7,
    GuestsAfterPdUntil15MinAfterFtPartiallyArrived = 8,
    GuestsAfterPdUntil15MinAfterFtNotyArrived = 9,
    GuestsAfterPdArrived = 10,
    GuestsAfter15MinAfterFtNotArrived = 11,
    GuestsAfter15MinAfterFtPartiallyArrived = 12,
    GuestsPartiallySeated = 13,
    GuestsSeated = 14,
    GuestsSeatedAfterNextPdStart = 15,
    GuestsSeatedAfterNextFtStart = 16,
}

export enum RoomPlanTableReservationStatus {
    Tentative = 0,
    AssignedBeforeOccupancy = 1,
    BeforeProductionPartiallyArrived = 2,
    BeforeProductionArrived = 3,
    AfterPdUntil15MinAfterFtPartiallyArrived = 4,
    AfterPdUntil15MinAfterFtNotArrived = 5,
    AfterPdArrived = 6,
    After15MinAfterFtNotArrived = 7,
    After15MinAfterFtPartiallyArrived = 8,
    PartiallySeated = 9,
    Seated = 10,
    SeatedAfterNextPdStart = 11,
    SeatedAfterNextFtStart = 12,
}

export interface IOperatorFulfillment {
    id: string;
    locationId: string;
    fulfillmentGroupId?: string;
    orderId: string;
    orderNumber: string;
    dailyOrderIncrement?: number;
    tableName: string;
    useCaseName?: IMultiLanguageText;
    roomId: string;
    orderDate: Date;
    items: Array<IOrderItem>;
    scheduledFulfillmentDateTime: Date;
    amendedReadyDateTime: Date;
    effectiveReadyDateTime?: Date;
    effectiveFulfillmentDateTime?: Date;
    isFulfilled: boolean;
    isPaid: boolean;
    cancellationState?: CancellationState;
    fulfillmentPositionDisplayMode: FulfillmentPositionDisplayMode;
    state: FulfillmentState;
    currentQueuePosition?: number;
    orderedByWaiterName?: string;
    orderHasOtherFulfillments: boolean;
    isLinked: boolean;
    customTableName?: string;
    orderHasDeliveryAddress: boolean;
}

export interface IExtendedOperatorFulfillment extends IOperatorFulfillment {
    fulfillmentGroup?: IFulfillmentGroup;
    productionState: FulfillmentProductionState;
}

export interface IOpenBill {
    billId: string;
    name: string;
    billCustomName?: string;
    billType: BillType;
    openSince: Date;
    openBillAmount: number;
    openBillAmountAfterDiscounts: number;
    operatorName: string;
    allocatedGuests: number;
    hasPreorder: boolean;
    latestPreorderDateTime?: Date;
    table: IBillTable;
}

export interface IBillTable {
    locationId: string;
    roomId: string;
    roomName: string;
    tableId: string;
    tableName: string;
    tableNumber: number;
    seats: number;
}

export interface IBaseOpenBill {
    // customName?: string;
    id: string;
    type: BillType;
}

export interface IPreorderShift {
    id: string;
    shiftName?: string;
    isAllDay: boolean;
    startUtc: Date;
    startString: string;
    endUtc: Date;
    endString: string;
    offerId: string;
    roomIds: string[];
    orderUseCaseIds: string[];
}
